import { GridCellProps } from '@progress/kendo-react-grid';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';

const ShoppingCartUomCell = (props: GridCellProps) => {
  const { value } = useGridCellDisplayValue(props);

  return (
    <GridCellBase {...props} rowSelectionEnabled={false} className="!p-0" title={value}>
      {value}
    </GridCellBase>
  );
};

export default ShoppingCartUomCell;
